import { useQuery } from 'react-query'
import { axios } from '../../../lib'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from '../../../services/api/types'
import { Orders } from '../types'
import { uniqueId } from 'lodash'

const loadOrders = (data: PaginatedParams<any>): PaginatedResponse<Orders> => {
  return axios.get('/orders', {
    params: {
      ...data
    }
  })
}

export function useLoadOrders(query: PaginatedParams<any>) {
  return useQuery(['orders', query], () => loadOrders(query), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar a listagem de pedidos', {
        toastId: 'loadOrders'
      }),
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: true,
    select: (data) => ({
      ...data,
      data: data.data.map((order) => ({ ...order, id: uniqueId() }))
    })
  })
}
